import React, { useState } from "react";

const Contact = () => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

  const [formData, setFormData] = useState({
    phone: "",
    email: "",
    location: "",
  });

  const [formErrors, setFormErrors] = useState({
    phone: "",
    email: "",
    location: "",
  });

  const handleChange = (field, value) => {

    if (field === 'phone' && value.length > 11) {
      return;
    }

    setFormData({
      ...formData,
      [field]: value,
    });

    // Clear errors when the user starts typing
    setFormErrors({
      ...formErrors,
      [field]: "",
    });
  };

  const handleSubmit = () => {
    // Perform validation before submitting
    const { phone, email, location } = formData;
    const newFormErrors = {};

    if (!formData.phone) {
      newFormErrors.phone = "Phone number is required";
    }
    else if (formData.phone.length !== 11) {
      newFormErrors.phone = "Phone number must be 11 digits";
    }

    // Add email validation if needed
    if (!formData.email) {
      newFormErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newFormErrors.email = "Invalid email format";
    }

    if (!formData.location) {
      newFormErrors.location = "Location is required";
    }

    // Check if there are any errors
    if (Object.keys(newFormErrors).length > 0) {
      setFormErrors(newFormErrors);
      return;
    }

    // Perform your submit logic here
    console.log("Form submitted:", formData);
    setFormData({
      phone: "",
      email: "",
      location: "",
    });
  };

  return (
    <div id="contact" className="contactWrapper">
      <img
        className="contactleftArrow"
        src="/images/home/contactleftArrow.png"
        alt="..."
      />
      <img
        className="contactrightArrow"
        src="/images/home/contactrightArrow.png"
        alt="..."
      />
      <div className="CenterDiv">
        <h3 className="contact-heading mt-3">CONTACT US</h3>
        <input
          type="number"
          name=""
          id=""
          placeholder="Phone No"
          className="input-field"
          value={formData.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
          style={{
            border: formErrors.phone ? '1px solid red' : '1px solid #ccc',
          }}
        />
        <span style={{ color: "red" }}>{formErrors.phone}</span>

        <input
          type="email"
          name=""
          id=""
          placeholder="Email"
          className="input-field"
          value={formData.email}
          onChange={(e) => handleChange("email", e.target.value)}
          style={{
            border: formErrors.email ? '1px solid red' : '1px solid #ccc',
          }}
        />
        <span style={{ color: "red" }}>{formErrors.email}</span>

        <input
          type="text"
          name=""
          id=""
          placeholder="Location"
          className="input-field"
          value={formData.location}
          onChange={(e) => handleChange("location", e.target.value)}
          style={{
            border: formErrors.location ? '1px solid red' : '1px solid #ccc',
          }}
        />
        <span style={{ color: "red" }}>{formErrors.location}</span>

        <button onClick={handleSubmit} type="submit" className="submit-btn">
          Submit
        </button>
      </div>
    </div>
  );
};

export default Contact;
